module.exports = __webpack_public_path__ + "img/features-2.abe9e0b5.png";